import angular from 'angular';
import identificationModal from './identificationModal';
import './style.scss';

export default angular
  .module('components.identificationModal', [])
  .component('identificationModal', identificationModal).name;
